import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { NgClass } from '@angular/common';

export interface CircleSegment {
  color: string;
  filled: number;
}

@Component({
  selector: 'ebeihilfe-segmented-circle',
  templateUrl: './circle-with-segments.component.html',
  styleUrls: ['./circle-with-segments.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass],
})
export class CircleWithSegmentsComponent {
  public current = input.required<number>();
  public readonly cx = 50;
  public readonly cy = 50;
  public maxAmount = input<number>(100);
  public progressText = input<string>('');
  public readonly radius = 35;
  public dashArray = computed(() => (this.maxAmount() === 1 ? 0 : 2 * Math.PI * this.radius - 10));
  public segmentSize = computed(() => 100 / this.maxAmount());
  public dashOffset = computed(() => this.dashArray() - (this.dashArray() * this.segmentSize()) / 100);
  public segments = computed(() => {
    const colorSegment = 'active',
      colorLast = this.maxAmount() === 1 ? 'inactive' : 'red',
      colorUsed = 'inactive';

    const segments: CircleSegment[] = [];
    let filled = 0;
    const size = 100 / this.maxAmount();

    for (let i = 0; i < this.maxAmount(); i++) {
      segments.push({
        color: this.current() > i ? (this.current() === 1 ? colorLast : colorSegment) : colorUsed,
        filled: filled,
      });
      filled += size;
    }
    return segments;
  });
  // starting segments at 10 o'clock
  public startAngle = computed(() => -90 - 360 / this.maxAmount() / 2);

  public getAngle(filled: number): number {
    return (filled * 360) / 100 + this.startAngle();
  }
}
